<details-section [title]="'simulationBuilder.SIMULATION_PROMPTS_TITLE' | transloco" [showDetails]="false">
  <!-- Self-authoring flow: QC Admin sees expand-to-edit; regular authors see nothing -->
  <ng-container *ngIf="isSelfAuthoringFlow">
    <ng-container *ngIf="isQcAdmin">
      <div *ngIf="conversePromptGroup" class="qcadmin-prompt">
        <span class="prompt-label">{{ 'simulationBuilder.CONVERSE_PROMPT_LABEL' | transloco }}</span>
        <div
          class="prompt-box-wrapper"
          [class.prompt-box-wrapper--refining]="isRefinementInProgress"
          [attr.title]="isRefinementInProgress ? ('simulationBuilder.REFINEMENT_IN_PROGRESS_TOOLTIP' | transloco) : null"
        >
          <div class="prompt-readonly-box" [class.prompt-readonly-box--frozen]="isRefinementInProgress">
            {{ currentPromptText }}
          </div>
        </div>
        <button
          type="button"
          class="expand-to-edit-link"
          [disabled]="getReadOnlyMode() || isRefinementInProgress"
          (click)="openModal()"
        >
          {{ 'simulationBuilder.CONVERSE_PROMPT_EXPAND_TO_EDIT' | transloco }}
        </button>
      </div>
    </ng-container>
  </ng-container>

  <!-- Non-self-authoring flow: autosave textarea for everyone (pre-SR-19613 behavior) -->
  <ng-container *ngIf="!isSelfAuthoringFlow">
    <div class="container" [formGroup]="form">
      <div *ngIf="conversePromptGroup" [formGroup]="conversePromptGroup">
        <qai-field [label]="'simulationBuilder.CONVERSE_PROMPT_ENTER_LABEL' | transloco">
          <textarea
            qai-textarea
            autosize
            [maxLines]="30"
            qaiPasteClean
            qaiTrimLeading
            formControlName="promptText"
          ></textarea>
        </qai-field>
      </div>
    </div>
  </ng-container>
</details-section>

<converse-prompt-override-modal
  *ngIf="isQcAdmin"
  [open]="modalOpen"
  [promptText]="currentPromptText"
  [callUuid]="callUuid"
  [isRefinementInProgress]="isRefinementInProgress"
  (closeModal)="onModalClose()"
  (overrideSuccess)="onOverrideSuccess($event)"
></converse-prompt-override-modal>
